export const APILIST = {
    EMAIL_VERIFY: "/auth/check-ev-token",
    CHECK_TOKEN: "/auth/check-fp-token",
    // CHECK_TOKEN: "/api/auth/check-rp-token",
    CHANGE_PASSWORD: "/auth/reset-password",
}
export default APILIST
